import {createEntityService} from 'utils/createEntityService';
import {DocumentTemplateProgram} from '../types/documentTemplateProgram';

export const DocumentTemplateProgramService =
  createEntityService<DocumentTemplateProgram>({
    baseUrl: 'api/v1/document_template_programs',
    entityName: 'documentTemplateProgram',
  });
